import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f230c69"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "electricity-usage"
}
const _hoisted_2 = { class: "electricity-usage__title h4" }
const _hoisted_3 = { class: "electricity-usage__description" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageContent.title), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.pageContent.description), 1),
        _createVNode(_component_RadioGroup, {
          modelValue: _ctx.estimatedUsage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.estimatedUsage) = $event)),
          class: "electricity-usage__options",
          options: _ctx.usageOptions
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_AppButton, {
          class: "electricity-usage__next-button",
          disabled: !_ctx.estimatedUsage,
          "full-width": "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('go-forward')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.nextStepButtonCopy), 1),
            _hoisted_4
          ], undefined, true),
          _: 1
        }, 8, ["disabled"])
      ]))
    : _createCommentVNode("", true)
}